import React from "react";

export default function CRM(props) {
  return (
    <>
      <div>
        {" "}
        <div id="smooth-wrapper">
          <div id="smooth-content">
            <div class="breadcrumb-section mb-120">
              <div class="container mb-70">
                <div class="row">
                  <div class="col-xl-8 col-lg-10">
                    <div class="breadcrumb-content">
                      <ul class="breadcrumb-list">
                        <li>
                          <a href="service-details.html#">Home</a>
                        </li>
                        <li>
                          <svg
                            width="24"
                            height="6"
                            viewBox="0 0 24 6"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M-3.26633e-05 2.88672L2.88672 5.77347L5.77347 2.88672L2.88672 -3.26633e-05L-3.26633e-05 2.88672ZM23.7735 2.88672L20.8867 -3.26633e-05L18 2.88672L20.8867 5.77347L23.7735 2.88672ZM2.88672 2.88672V3.38672H20.8867V2.88672V2.38672H2.88672V2.88672Z" />
                          </svg>
                          CRM
                        </li>
                      </ul>
                      <h1>Customer relationship management (CRM)</h1>
                      <div class="para">
                        <div class="icon">
                          <svg
                            width="6"
                            height="49"
                            viewBox="0 0 6 49"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M2.88672 -3.26633e-05L-3.26633e-05 2.88672L2.88672 5.77347L5.77347 2.88672L2.88672 -3.26633e-05ZM2.88672 48.7735L5.77347 45.8867L2.88672 43L-3.26633e-05 45.8867L2.88672 48.7735ZM2.88672 2.88672H2.38672L2.38672 45.8867H2.88672H3.38672L3.38672 2.88672H2.88672Z" />
                          </svg>
                        </div>
                        <p>
                          {" "}
                          With Insight Wide CRM organisations can excel in
                          customer acquisition, retention and satisfaction.
                          Consolidating all customer, prospect and supplier
                          information creates a single source of truth.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

              <div class="home5-banner-section">
                <div class="banner-content-wrapper">
                    <div class="container one">
                        <div class="banner-content text-center">
                            <div class="banner-icon">
                                <img src="assets/image/sass/vector/banner-vector4.svg" alt=""/>
                            </div>
                            <h1>One Platform. Infinite Growth.</h1>
                            <p>Whether you’re looking for a powerful ready-to-go subscription to hit the ground running or a fully custom CRM built from the ground up for your specific workflow, Insight Wide has you covered.</p>
                           
                            <ul>
                                <li>
                                    <div class="icon">
                                        <img src="assets/image/sass/vector/banner-vector1.svg" alt=""/>
                                    </div>
                                    <div class="content">
                                        <h2> Easy To Use</h2>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon">
                                        <img src="assets/image/sass/vector/banner-vector2.svg" alt=""/>
                                    </div>
                                    <div class="content">
                                        <h2>Custom CRM</h2>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon">
                                        <img src="assets/image/sass/vector/banner-vector3.svg" alt=""/>
                                    </div>
                                    <div class="content">
                                        <h2>Subscription Option Available</h2>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="banner-img-area">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12 d-flex justify-content-center mb-120">
                                <div class="banner-img">
                                    <img src="assets/crm-banner.png" alt=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="service-details-page mb-120">
              <div class="container">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="service-details-content-wrap">
                      <div class="row mb-40">
                        <div class="col-lg-12">
                          <div class="service-details-title">
                            <h2>Manage relationships, gather insights</h2>
                          </div>
                        </div>
                      </div>
                      <div class="row gy-4 mb-80">
                        <div class="col-lg-6">
                          <div class="details-content">
                            <h3> Overview:</h3>
                            <p>
                              Business leaders can analyse needs with ease to
                              identify who requires the most attention and
                              recognise the business processes that deliver
                              superior service to promote repeat business. All
                              data collected can be fully leveraged to assist
                              sales force automation, customer service/support 
                              and marketing.
                            </p>
                          </div>
                        </div>
                        <div class="col-lg-6 d-flex justify-content-lg-center">
                          <div class="details-content">
                            <h3> Our Approach:</h3>
                            <ul class="approach-list">
                              <li>Discover & Research</li>
                              <li>Strategy & Planning</li>
                              <li>Execution & Optimization</li>
                              <li>Measure & Scale</li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div class="row mb-70">
                        <div class="col-lg-12">
                          <div class="service-details-title mb-20">
                            <h2>Key Features:</h2>
                          </div>
                          <div class="key-features-area">
                            <ul class="key-features-list">
                              <li>Automation </li>
                              <li class="two">Analytics</li>
                              <li class="three">Centralization</li>
                              <li class="two">Scalability</li>
                              <li class="four">Integration </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-80">
                        <div class="col-lg-12">
                          <div class="service-details-title mb-40">
                            <h2>Why Choose Us:</h2>
                          </div>
                          <div class="why-choose-area-wrap">
                            <div class="row g-0">
                              <div class="col-lg-6">
                                <div class="why-choose-area">
                                  <ul class="why-choose-list">
                                    <li>
                                      <div class="icon">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g>
                                            <path
                                              fill-rule="evenodd"
                                              clip-rule="evenodd"
                                              d="M6.0655 11.4289L8.23374 13.7583C9.57941 12.3163 15.5608 5.27243 19 2C15.4382 6.991 12.3418 12.1977 9.55693 17.4299C9.15734 18.1804 7.73243 18.1932 7.31286 17.4488C5.98626 15.0959 4.56 12.7577 3 10.4859C4.12158 10.3195 5.31763 10.5969 6.06527 11.4289H6.0655Z"
                                            />
                                          </g>
                                        </svg>
                                      </div>
                                      <div class="content">
                                        <p>
                                          <span>Everything in One Place:–</span>{" "}
                                          No more jumping between different
                                          apps. We consolidate your CRM,
                                          marketing, and analytics into one
                                          powerful platform so you can manage
                                          your whole business from a single
                                          dashboard.
                                        </p>
                                      </div>
                                    </li>
                                    <li>
                                      <div class="icon">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g>
                                            <path
                                              fill-rule="evenodd"
                                              clip-rule="evenodd"
                                              d="M6.0655 11.4289L8.23374 13.7583C9.57941 12.3163 15.5608 5.27243 19 2C15.4382 6.991 12.3418 12.1977 9.55693 17.4299C9.15734 18.1804 7.73243 18.1932 7.31286 17.4488C5.98626 15.0959 4.56 12.7577 3 10.4859C4.12158 10.3195 5.31763 10.5969 6.06527 11.4289H6.0655Z"
                                            />
                                          </g>
                                        </svg>
                                      </div>
                                      <div class="content">
                                        <p>
                                          <span>User-First Design –</span> We
                                          don’t do "ugly" software. Our UI is
                                          clean, modern, and incredibly easy to
                                          use, meaning your team actually enjoys
                                          using it without needing a 100-page
                                          manual.
                                        </p>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div class="col-lg-6">
                                <div class="why-choose-area">
                                  <ul class="why-choose-list">
                                    <li class="justify-content-lg-end">
                                      <div class="icon">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g>
                                            <path
                                              fill-rule="evenodd"
                                              clip-rule="evenodd"
                                              d="M6.0655 11.4289L8.23374 13.7583C9.57941 12.3163 15.5608 5.27243 19 2C15.4382 6.991 12.3418 12.1977 9.55693 17.4299C9.15734 18.1804 7.73243 18.1932 7.31286 17.4488C5.98626 15.0959 4.56 12.7577 3 10.4859C4.12158 10.3195 5.31763 10.5969 6.06527 11.4289H6.0655Z"
                                            />
                                          </g>
                                        </svg>
                                      </div>
                                      <div class="content">
                                        <p>
                                          <span>
                                            Work Smarter, Not Harder –
                                          </span>{" "}
                                          Stop wasting time on repetitive manual
                                          tasks. Our smart automation handles
                                          the grunt work for you, reducing human
                                          error and freeing you up to focus on
                                          growing your brand.
                                        </p>
                                      </div>
                                    </li>
                                    <li class="justify-content-lg-end">
                                      <div class="icon">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g>
                                            <path
                                              fill-rule="evenodd"
                                              clip-rule="evenodd"
                                              d="M6.0655 11.4289L8.23374 13.7583C9.57941 12.3163 15.5608 5.27243 19 2C15.4382 6.991 12.3418 12.1977 9.55693 17.4299C9.15734 18.1804 7.73243 18.1932 7.31286 17.4488C5.98626 15.0959 4.56 12.7577 3 10.4859C4.12158 10.3195 5.31763 10.5969 6.06527 11.4289H6.0655Z"
                                            />
                                          </g>
                                        </svg>
                                      </div>
                                      <div class="content">
                                        <p>
                                          <span>Built to Scale–</span> Whether
                                          you're a lean startup or a growing
                                          enterprise, Insight Wide adapts to
                                          your needs. Our solutions are
                                          flexible, future-proof, and designed
                                          to grow exactly as fast as you do.
                                        </p>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
